import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {localStorageFunc, notify} from '../../helpers/utility';

export const getDispositionStart = () => {
  return {
    type: actionTypes.GET_DISPOSITION_START,
  };
};

export const getDispositionFail = (error) => {
  return {
    type: actionTypes.GET_DISPOSITION_FAIL,
    error: error,
  };
};

export const getDispositionSuccess = (agentId, dispositions, currentGmtTime, operation, timeDiff) => {
  return {
    type: actionTypes.GET_DISPOSITION_SUCCESS,
    dispositions: dispositions,
    currentGmtTime: currentGmtTime,
    operation: operation,
    timeDiff: timeDiff,
   
  };
};

export const getDisposition = (agentId) => {
  return (dispatch) => {
    dispatch(getDispositionStart());
    ctiRequest['CTI_GET_DISPOSITION'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_GET_DISPOSITION'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_GET_DISPOSITION'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS' || result.data.response.reason === 'Disposition information not available') {
          dispatch(getDispositionSuccess(agentId, result.data.response.dispositions, result.data.response.gmtTime.currentGmtTime, result.data.response.gmtTime.operation, result.data.response.gmtTime.timeDiff));
        } else {
          notify('Disposition Error: ' + result.data.response.reason, 'call-disposition');
          dispatch(getDispositionFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        //notify('Disposition Error', 'call-disposition');
        dispatch(getDispositionFail(err));
      });
  };
};

export const setDispositionStart = () => {
  return {
    type: actionTypes.SET_DISPOSITION_START,

  };
};

export const setDispositionFail = (error, status) => {
  return {
    type: actionTypes.SET_DISPOSITION_FAIL,
    error: error,
    status: status
  };
};


export const setDispositionSuccess = (agentId, status) => {
  return {
    type: actionTypes.SET_DISPOSITION_SUCCESS,
    status: status

  };
};

export const setDispositionReset = (agentId, status) => {

  return {
    type: actionTypes.SET_DISPOSITION_RESET,
    status: status,
  }
}

export const setDisposition = (agentId, category, subDisp, remarks,nextCallTime, actionOriginate, confLeadId) => {
  return (dispatch) => {
    dispatch(setDispositionStart());
    ctiRequest['CTI_SET_DISPOSITION'].agent_id = agentId;
    ctiRequest['CTI_SET_DISPOSITION'].category = category;
    ctiRequest['CTI_SET_DISPOSITION'].cust_disp = subDisp;
    ctiRequest['CTI_SET_DISPOSITION'].next_call_time = nextCallTime;
    ctiRequest['CTI_SET_DISPOSITION'].remarks = remarks;
    ctiRequest['CTI_SET_DISPOSITION'].conf_lead_id = actionOriginate ? confLeadId : 0;
    window.clientIP = localStorage.getItem('clientIP') || '127.0.0.1';
    ctiRequest['CTI_SET_DISPOSITION'].ip = window.clientIP;
    
    axios.post('/', ctiRequest['CTI_SET_DISPOSITION'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          notify('Disposition successfully updated', 'call-disposition', 'success');
          dispatch(setDispositionSuccess(agentId, result.data.response.status));
          // dispatch(setDispositionReset());
        } else {
          notify('Disposition Error: ' + result.data.response.reason, 'call-disposition');
          dispatch(setDispositionFail(result.data.response.reason, result.data.response.status));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Disposition Error', 'call-disposition');
        dispatch(setDispositionFail(err.message, 'FAILURE'));
      });
  };
};

